import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { NotifPref } from '@/types';

// Preferencias de notificaciones de Teams del usuario actual. El backend las
// resuelve por el JWT, así que no lleva parámetro de usuario.
export function useNotifPrefs() {
  return useQuery({
    queryKey: ['notif-prefs'],
    queryFn: () => api.notifPrefs.get(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateNotifPrefs() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (prefs: NotifPref) => api.notifPrefs.update(prefs),
    onSuccess: (data) => {
      // Escribimos el resultado al cache directo para que el switch no parpadee.
      qc.setQueryData(['notif-prefs'], data);
    },
  });
}
